import { IFilter, TFilter } from '../../types/filters';
import { advancedFilters } from './advancedFilters';
import { area } from './area';
import { bedrooms } from './bedrooms';
import { dealType } from './dealType';
import { geo } from './geo';
import { landArea } from './landArea';
import { offerType } from './offerType';
import { posessor } from './posessor';
import { price } from './price';
import { roomType } from './roomType';

export const FILTERS: { [key in TFilter]: IFilter } = {
  advancedFilters,
  area,
  bedrooms,
  dealType,
  geo,
  landArea,
  offerType,
  posessor,
  price,
  roomType,
};
